export default ".menu-color {\r\n    color: white;\r\n    padding-right: 10px;\r\n}\r\n.pad-right{\r\n    padding-right: 10px;\r\n}"